module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-section"
  }, [(_vm.hasTitle) ? _c('div', {
    staticClass: "section-header"
  }, [(_vm.hasIcon) ? _c('div', {
    staticClass: "section-icon"
  }, [_c('rt-icon', {
    attrs: {
      "name": _vm.icon,
      "size": 16
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.showMore) ? _c('span', {
    staticClass: "section-more",
    on: {
      "click": _vm.moreClick
    }
  }, [_vm._v("更多")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-btns"
  }, [_vm._t("btn")], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b45135a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/section/rtSection.vue
// module id = 1375
// module chunks = 96